<span class="delete-button-wrapper" *ngIf="!isSideBar">
  <button class="btn btn-danger delete-button" (click)="openDeleteModal()"
          tabindex="0" role="button" (keydown.enter)="openDeleteModal()"
          [disabled]="!canDelete || pageLoading">
    Delete Form
  </button>
</span>

<a href="javascript:void(0);" (click)="openDeleteModal()" (keydown.enter)="openDeleteModal()" tabindex="0" *ngIf="isSideBar">
  <i class="fa fa-trash"aria-hidden="true"></i>&nbsp;&nbsp;delete form
</a>

<ejs-dialog #deleteModal [isModal]='isModal' [buttons]='buildDlgButtons' [visible]='buildModalDialogVisible'
            [position]='position' [animationSettings]='animationSettings' [width]='modalWidth' (open)="openDeleteModal()">
  <ng-template #content>
    <div class="card">
      <div class="card-header bg-primary">
        <h3 class="card-title text-white" tabindex="0" role="heading" aria-level="1">Are you sure?</h3>
      </div>
      <div class="card-body">
        <label *ngIf="isBaseRevision">
          <span class="emphasis" tabindex="0">Deleting a form and all its revisions cannot be undone.</span>
          If a related draft of this form exists, it will not be deleted and will remain in the system.
        </label>
        <label *ngIf="isDraft">
          <span class="emphasis" tabindex="0">Deleting a draft form cannot be undone.</span>
          This will only delete this draft and not any of the related revisions.
        </label>
        <label *ngIf="isDelivery">
          <span class="emphasis" tabindex="0">Deleting a built SPL file cannot be undone.</span>
          If a related form or draft form exists, it will not be deleted and will remain in the system.This will only delete this SPL and not any of the related revisions.
        </label>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
